import { render, staticRenderFns } from "./HostingComparativa.vue?vue&type=template&id=af22128a&scoped=true"
import script from "./HostingComparativa.vue?vue&type=script&lang=js"
export * from "./HostingComparativa.vue?vue&type=script&lang=js"
import style0 from "./HostingComparativa.vue?vue&type=style&index=0&id=af22128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22128a",
  null
  
)

export default component.exports